import { Strapi_NavbarLinkEntity } from 'src/types'

const getDropdownOptions = (data?: Strapi_NavbarLinkEntity[], locale?: string) => {
  if (!data) {
    return []
  }
  return data.map(link => {
    const currentUrl =
      locale === 'en' && link.attributes?.name === 'Trading articles' ? link.attributes?.urlEn : link.attributes?.url
    return {
      name: link.attributes?.name || '',
      url: currentUrl || '',
      badgeType: link.attributes?.badgeType,
      includeLangsArr: link.attributes?.includeLangsArr,
      showChat: link.attributes?.showChat,
      component: link.attributes?.component,
    }
  })
}

export default getDropdownOptions
